import { useSelector } from 'react-redux'

import { getAppointmentId } from '~/store/reducers/soap'

import { useCorrelationIdLock } from './useCorrelationIdLock'

export const useAudioRecorderSession = () => {
  const currentAppointmentId = useSelector(getAppointmentId)
  const lockedCorrelationId = useCorrelationIdLock()

  // Use locked correlationId if active, otherwise use current appointmentId
  // Ensure correlationId is always a string (required by library)
  const correlationId = lockedCorrelationId || currentAppointmentId || ''

  return {
    appName: 'rhapsody' as const,
    correlationId,
  }
}
